// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IServicePlanDto
 */
export interface IServicePlanDto {
    /**
     * 
     * @type {number}
     * @memberof IServicePlanDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IServicePlanDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IServicePlanDto
     */
    account_type?: IServicePlanDtoAccountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IServicePlanDto
     */
    order?: number;
}

/**
* @export
* @enum {string}
*/
export enum IServicePlanDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IServicePlanDto interface.
 */
export function instanceOfIServicePlanDto(value: object): value is IServicePlanDto {
    return true;
}

export function IServicePlanDtoFromJSON(json: any): IServicePlanDto {
    return IServicePlanDtoFromJSONTyped(json, false);
}

export function IServicePlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServicePlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function IServicePlanDtoToJSON(json: any): IServicePlanDto {
    return IServicePlanDtoToJSONTyped(json, false);
}

export function IServicePlanDtoToJSONTyped(value?: IServicePlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'name': value['name'],
        'account_type': value['account_type'],
        'order': value['order'],
    };
}

